import {
    Button,
    ModalBody,
    ModalDialog,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from '@flos/react-ui';
import {
    type TermDTO,
    type CoverageDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { formatStringToMonetaryValueString } from '../../utils/coverablesUtil';
import { useHippoText } from '../../hooks/useHippoText';

const VaryingDeductableModal = ({
    showModal,
    closeModal,
    coverage,
    deductibleTerms
}: {
    showModal: boolean;
    closeModal: () => void;
    coverage: CoverageDTO;
    deductibleTerms: TermDTO[];
}): React.JSX.Element => {
    const getformattedTermValue = (term: TermDTO): string => {
        if (term.name === undefined || term.value === undefined) {
            return '';
        }
        if (term.publicId?.includes('DedPerc') && !term.value.includes('%')) {
            return `${term.value} %`;
        }
        if (term.value.includes('%') || term.name.includes('Selvrisikotype')) {
            return `${term.value}`;
        }
        return `${formatStringToMonetaryValueString(term.value)} `;
    };

    const getHippoText = useHippoText();
    const titleText = getHippoText('DSS-VARYING-DEDUCTIBLE-TITLE');

    return (
        <ModalOverlay
            isOpen={showModal}
            onDismiss={() => {
                closeModal();
            }}
        >
            <ModalDialog
                closeIconHandler={() => {
                    closeModal();
                }}
            >
                <ModalHeader title={`${titleText} ${coverage.name ?? ''}`}>
                    <p className="u-spacing-inset-m--stretch-max u-spacing-stack-none">
                        {getHippoText('DSS-VARYING-DEDUCTIBLE-SUBTITLE')}
                    </p>
                </ModalHeader>
                <ModalBody>
                    {deductibleTerms.map((term) => {
                        return (
                            <div key={term.name} className="u-flex-box u-flex-box--space-between">
                                <p>{term.name}</p>
                                <p>{getformattedTermValue(term)}</p>
                            </div>
                        );
                    })}
                </ModalBody>
                <ModalFooter className="u-text-left">
                    <Button
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        {getHippoText('DSS-COMMON-CLOSE')}
                    </Button>
                </ModalFooter>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default VaryingDeductableModal;
